namespace Areas.ContractorPay.Profile{
    "use strict";


    export function onProfileContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);

    }

    export function view() {
        gotoSelected("ContractorPayProfileForm", "/ContractorPay/Profile/View/");
    }

    export function edit() {
        gotoSelected("ContractorPayProfileForm", "/ContractorPay/Profile/Edit/");
    }


    //select Account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ContractorPayProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.AccountId = data.accountId;
            formData.AccountName = data.accountName;

            form.option("formData", formData);

        }
    }

    export function selectAccount() {
        const form: any = $("#ContractorPayProfileForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }


    //select Contract
    function contractDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#ContractorPayProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.ContractId = data.contractId;
            formData.ContractName = data.contractName;
            formData.ContractAmount = data.contractAmount;
            formData.ContractType = data.contractType;
            formData.ContractStartDate = data.executionDate;
            formData.ConstructionStartDate = data.ntpDate;
            formData.CompletionDate = data.adjustedEstimatedCompletionDate;
            formData.PACNumber = data.pacNumber;


            const completionDate = moment(data.adjustedEstimatedCompletionDate);
            const constructionDate = moment(data.ntpDate);

            formData.NumberOfDays = completionDate.diff(constructionDate, "days");

            form.option("formData", formData);

        }
    }

    export function selectContract() {
        const form: any = $("#ContractorPayProfileForm").dxForm("instance");

        const contractLookupDialog =
            new Areas.Dialogs.ContractDialog(contractDialogClosing());
    }

    export function goToActions(sharePointLink: string, projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToSharePoint(sharePointLink) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }
}